import styled from "styled-components";

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  padding: 24px;
  width: 580px;
  background: #ffffff;
  border-radius: 8px;
`;

export const Row = styled.div`
  display: flex;
  align-items: center;
`;

export const Header = styled.div``;

export const Body = styled.div``;

export const TextTitle = styled.p`
  font-family: Inter;
  font-size: 24px;
  font-weight: 700;
  line-height: 29.05px;
  letter-spacing: -0.01em;
  text-align: left;
  color: #101828;
`;

export const CloseButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
`;

export const SpaceY: any = styled.div`
  height: ${(props: any) => props.space}px !important;
`;

export const SpaceX: any = styled.div`
  width: ${(props: any) => props.space}px !important;
`;

export const CancelButton = styled.button`
  background: #ffffff;
  width: 100%;
  height: 44px;
  border: 1px solid #a3a3a6;
  border-radius: 8px;
  padding: 10px 18px;
  cursor: pointer;

  font-family: Inter;
  font-size: 16px;
  font-weight: 500;
  line-height: 19.2px;
`;

export const SendButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  background: #2d5bff;
  width: 100%;
  height: 44px;
  border: none;
  border-radius: 8px;
  padding: 10px 18px;
  cursor: pointer;

  font-family: Inter;
  font-size: 16px;
  font-weight: 500;
  line-height: 19.2px;
  color: #ffffff;
`;

export const TextPagamentoSinal = styled.p`
  font-family: Inter;
  font-size: 16px;
  font-weight: 400;
  line-height: 12px;
  text-align: left;
`;
